import Vue from 'vue'
// import axios from 'axios'
import axios from '@/wrappers/axios.js'

const UserService = {

    userList(params) {
        return new Promise(async (resolve, reject) => {
            axios
                .get(`/users${params ? params : ''}`)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    },

    getUser(id, params) {
        return new Promise(async (resolve, reject) => {
            axios
                .get(`/users/${id}`, { params: params || {} })
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    },

    updateUser(id, data) {
        return new Promise(async (resolve, reject) => {
            axios
                .put(`/users/${id}`, data)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    },

    appList(id) {
        return new Promise(async (resolve, reject) => {
            axios
                .get(`/users/${id}/apps`)
                .then(response => {
                    resolve(response)
                })
                .catch(e => reject(e));
        })
    },

    addApps(id,data) {
        return new Promise(async (resolve, reject) => {
            axios
                .post(`/users/${id}/apps`,data)
                .then(response => {
                    resolve(response)
                })
                .catch(e => reject(e));
        })
    },

    addTag(user_id, tag_id) {
        const tag_ids = Array.isArray(tag_id) ? tag_id : [tag_id];
        return new Promise((resolve, reject) => {
            axios.put(`/users/${user_id}/tags`, { tag_ids })
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => reject(err));
        });
    },

    removeTag(user_id, tag_id) {
        const tag_ids = Array.isArray(tag_id) ? tag_id : [tag_id];
        return new Promise((resolve, reject) => {
            // NOTE: A slightly different syntax for axios DELETE
            // requests when sending data with our request too.
            // (can use method spoofing via "_method" field)
            axios.delete(`/users/${user_id}/tags`, { data: { tag_ids } })
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => reject(err));
        });
    },
    deleteUser(id){
        return new Promise((resolve, reject) => {
            // NOTE: A slightly different syntax for axios DELETE
            // requests when sending data with our request too.
            // (can use method spoofing via "_method" field)
            axios.delete(`/users/${id}`)
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => reject(err));
        });
    },
    restoreUser(id){

        return new Promise((resolve, reject) => {
            // NOTE: A slightly different syntax for axios DELETE
            // requests when sending data with our request too.
            // (can use method spoofing via "_method" field)
            axios.post(`/users/${id}/restore`)
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => reject(err));
        });
    }
}

Vue.$userService = UserService

export default UserService